export default __webpack_public_path__ + "static/media/icon-video-transcript_white.b218eb18.svg";